import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.settlement');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-settlement',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.settlement/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSettlementComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public sub: string = '';
    public sectionTitle: string = '정산관리';
    public routerSub: any;

    public categories: any = {
        'manage': {
            label: '정산관리',
            items: ['매출수기등록', '코너별정산내역']
        },
        'revenue': {
            label: '수익관리',
            items: ['입고대비 수익분석', '원가대비 수익분석', '매장별 입고대비 수익분석']
        }
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.updateRoute();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.updateRoute();
                await this.service.render();
            }
        });
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private updateRoute() {
        const seg = WizRoute.segment;
        this.category = seg.category || 'manage';
        try { this.sub = seg.sub ? decodeURIComponent(seg.sub) : ''; } catch { this.sub = seg.sub || ''; }
        if (!seg.category) {
            this.service.href('/settlement/manage');
        }
    }

    public categoryKeys(): string[] {
        return Object.keys(this.categories);
    }

    public selectSub(item: string) {
        this.sub = item;
        this.service.render();
    }

    public isActiveCat(key: string): boolean {
        return this.category === key;
    }
}

export default PageSettlementComponent;